import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Group} from "../../../../../types/interfaces";
import {ModalController} from "@ionic/angular";
import {MyGreenCountry} from "../../../../../services/mygreencountry/my-greencountry";
import {
    EXCLUDED_GROUP_TYPES_FOR_PRACTICING,
    GROUP_TYPE_ENG_TEACHER, GROUP_TYPE_IELTS,
    GROUP_TYPE_URK_TEACHER,
    GROUP_TYPE_ZNO,
} from "../../../../constants";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {TranslocoService} from "@jsverse/transloco";


type MessageType = 'telegram' | 'practicing' | 'studentsMeeting' | 'meeting';

@Component({
    selector: 'app-practicing',
    templateUrl: './practicing.component.html',
    styleUrls: ['./practicing.component.scss'],
})
export class PracticingComponent implements OnInit {

    @Input() groups: Group[] | undefined = undefined;
    @Input() type: MessageType = 'practicing';
    @Input() open: boolean = false;
    @Output() openTransferModal: EventEmitter<string> = new EventEmitter();

    protected readonly GROUP_TYPE_URK_TEACHER: number = GROUP_TYPE_URK_TEACHER;
    protected readonly GROUP_TYPE_ENG_TEACHER: number = GROUP_TYPE_ENG_TEACHER;
    protected readonly GROUP_TYPE_ZNO: number = GROUP_TYPE_ZNO;
    protected readonly GROUP_TYPE_IELTS: number = GROUP_TYPE_IELTS;
    public showTransferringContainer: boolean = false;
    public hideTransferLessonBtn: boolean = false;

    constructor(private modalCtrl: ModalController,
                public myGcService: MyGreenCountry,
                private sanitizer: DomSanitizer,
                private translocoService: TranslocoService) {
    }

    ngOnInit() {

        if (this.type === 'practicing' && this.groups) {

            this.groups = this.groups.filter(group =>
                !EXCLUDED_GROUP_TYPES_FOR_PRACTICING.has(group.typeCourse) && !group.isReserve
            );

            this.hideTransferLessonBtn = this.groups.some(group => group.time == 'isPast')
        }

    }


    close() {
        return this.modalCtrl.dismiss(null, 'cancel');
    }

    openUrl(url: string | undefined) {

        if (url) {
            this.myGcService.openUrl(url)
        }

    }


    getMessage(type: number): SafeHtml {
        let message = '';

        if (type === this.GROUP_TYPE_ZNO || type === this.GROUP_TYPE_IELTS) {
            // message = PRACTICING_MESSAGE_GROUP_TYPE_ZNO;
            message = this.translocoService.translate('practicing.message.typeZno');
        } else if (type === this.GROUP_TYPE_ENG_TEACHER) {
            // message = PRACTICING_MESSAGE_GROUP_TYPE_ENG_TEACHER;
            message = this.translocoService.translate('practicing.message.typeEngTeacher');
        } else {
            // message = PRACTICING_MESSAGE;
            message = this.translocoService.translate('practicing.message');
        }

        return this.sanitizer.bypassSecurityTrustHtml(message);
    }

    openTransferLessonModal() {
        return this.modalCtrl.dismiss(null, 'openTransferModal');
    }

}
